
import { onMounted, reactive, ref, computed } from "vue";
import { useRouter } from "vue-router";
import * as XLSX from "xlsx";
import { EllipsisOutlined } from "@ant-design/icons-vue";
import XAtable from "@/components/XATable.vue";
import UserSelect from "@/components/UserSelect.vue";
import {
  sysAdsQueryList,
  sysNovelConfigList,
  userAddAppUser,
  sysAdsSave,
  userQueryPageList,
  bmQueryList,
  bmDel,
  bmSave,
  sysDataQueryList,
  sysAdsCleanAmount,
  sysAdsSubAmount,
  sysAdsExpendList,
  sysAdsExpendCount,
  sysAdsSaveExpend,
  commonUpload,
  sysLabelQueryList,
  sysLabelSave,
  sysLabelDel,
  sysAdsXls,
  sysAdsRecycle,
  sysExpendGetExpendxls,
} from "@/api/api";
import XDialog from "@/components/XDialog.vue";
import type { Rule } from "ant-design-vue/es/form";
import type { FormInstance } from "ant-design-vue";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { message } from "ant-design-vue";
import { hasPermission } from "@/utils/permission";
import { getUserInfo } from "@/utils/auth";
type RangeValue = [Dayjs, Dayjs];

interface SearchFormState {
  // appId: string | number;
  // time: RangeValue;
  accountState: string;
  adsId: string;
  userId: string;
  userType: number | string | null;
  // frozenState: string;
  pageNo: number;
  pageSize: number;
}

interface FormState {
  accountState: number;
  adsId: string;
  adsName: string;
  bmName: string;
  //   company: string;
  // frozenState: number;
  id: string;
  userId: string;
  applyState: number;
  price: number;
  amount: number;
  expendAmount: number;
  url: string;
  gmt: string;
  remark: string;
  stopType: number;
}
export default {
  components: {
    XAtable,
    XDialog,
    UserSelect,
    EllipsisOutlined,
  },
  setup() {
    const router = useRouter();
    const searchFormState = reactive<SearchFormState>({
      // frozenState: "",
      accountState: "",
      adsId: "",
      userId: "",
      userType: "",
      pageNo: 1,
      pageSize: 10,
    });
    const formState = reactive<FormState>({
      accountState: 1,
      adsId: "",
      adsName: "",
      bmName: "",
      //   company: "",
      // frozenState: 0,
      id: null,
      userId: "",
      applyState: 0,
      price: 0,
      amount: 0,
      expendAmount: 0,
      url: "",
      gmt: "",
      remark: "",
      stopType: 0,
    });

    // 备注标签数组（用于下拉选择显示）
    const remarkArray = ref<string[]>([]);

    // 时区列表（完整版：27个整点时区 + 5个半小时区 + 3个45分钟区 = 35个）
    const timeZoneList = [
      // 西时区（GMT-12 到 GMT-1）
      { value: "GMT-12", label: "GMT-12 (IDLW) - 国际日期变更线西侧时间" },
      { value: "GMT-11", label: "GMT-11 (NUT) - 纽埃时间" },
      { value: "GMT-10", label: "GMT-10 (HST) - 夏威夷标准时间" },
      { value: "GMT-9:30", label: "GMT-9:30 (MART) - 马克萨斯群岛时间" },
      { value: "GMT-9", label: "GMT-9 (AKST) - 阿拉斯加标准时间" },
      { value: "GMT-8", label: "GMT-8 (PST) - 美国太平洋标准时间" },
      { value: "GMT-7", label: "GMT-7 (MST) - 美国山地标准时间" },
      { value: "GMT-6", label: "GMT-6 (CST) - 美国中部标准时间" },
      { value: "GMT-5", label: "GMT-5 (EST) - 美国东部标准时间" },
      { value: "GMT-4", label: "GMT-4 (AST) - 大西洋标准时间" },
      { value: "GMT-3:30", label: "GMT-3:30 (NST) - 纽芬兰标准时间" },
      { value: "GMT-3", label: "GMT-3 (ART) - 阿根廷时间" },
      { value: "GMT-2", label: "GMT-2 (FNT) - 费尔南多·迪诺罗尼亚时间" },
      { value: "GMT-1", label: "GMT-1 (AZOT) - 亚速尔群岛时间" },

      // 零时区
      { value: "GMT+0", label: "GMT+0 (UTC) - 协调世界时" },

      // 东时区（GMT+1 到 GMT+14）
      { value: "GMT+1", label: "GMT+1 (CET) - 中欧时间" },
      { value: "GMT+2", label: "GMT+2 (EET) - 东欧时间" },
      { value: "GMT+3", label: "GMT+3 (MSK) - 莫斯科时间" },
      { value: "GMT+3:30", label: "GMT+3:30 (IRST) - 伊朗标准时间" },
      { value: "GMT+4", label: "GMT+4 (GST) - 海湾标准时间" },
      { value: "GMT+4:30", label: "GMT+4:30 (AFT) - 阿富汗时间" },
      { value: "GMT+5", label: "GMT+5 (PKT) - 巴基斯坦标准时间" },
      { value: "GMT+5:45", label: "GMT+5:45 (NPT) - 尼泊尔时间" },
      { value: "GMT+5:30", label: "GMT+5:30 (IST) - 印度标准时间" },
      { value: "GMT+6", label: "GMT+6 (BST) - 孟加拉标准时间" },
      { value: "GMT+6:30", label: "GMT+6:30 (MMT) - 缅甸时间" },
      { value: "GMT+7", label: "GMT+7 (ICT) - 印度支那时间" },
      { value: "GMT+8", label: "GMT+8 (CST) - 中国标准时间" },
      { value: "GMT+8:45", label: "GMT+8:45 (ACWST) - 澳大利亚中西部标准时间" },
      { value: "GMT+9", label: "GMT+9 (JST) - 日本标准时间" },
      { value: "GMT+9:30", label: "GMT+9:30 (ACST) - 澳大利亚中部标准时间" },
      { value: "GMT+10", label: "GMT+10 (AEST) - 澳大利亚东部标准时间" },
      { value: "GMT+10:30", label: "GMT+10:30 (LHST) - 豪勋爵岛标准时间" },
      { value: "GMT+11", label: "GMT+11 (VUT) - 瓦努阿图时间" },
      { value: "GMT+12", label: "GMT+12 (NZST) - 新西兰标准时间" },
      { value: "GMT+12:45", label: "GMT+12:45 (CHAST) - 查塔姆群岛标准时间" },
      { value: "GMT+13", label: "GMT+13 (TOT) - 汤加时间" },
      { value: "GMT+14", label: "GMT+14 (LINT) - 莱恩群岛时间" },
    ];

    const isAdd = ref(1);
    const dislogVisible = ref(false);
    const addLoading = ref(false);
    const batchAddVisible = ref(false);
    const batchAddLoading = ref(false);
    const batchAddList = ref<any[]>([]);
    const batchAddColumns = computed(() => {
      const cols = [
        { title: "账户名称", dataIndex: "adsName", key: "adsName", width: 120 },
        { title: "时区", dataIndex: "gmt", key: "gmt", width: 80 },
        { title: "广告账户ID", dataIndex: "adsId", key: "adsId", width: 120 },
        { title: "母BMID", dataIndex: "bmName", key: "bmName", width: 100 },
        { title: "用户ID", dataIndex: "userId", key: "userId", width: 80 },
        {
          title: "账号状态",
          dataIndex: "accountState",
          key: "accountState",
          width: 80,
          customRender: ({ text }: { text: number }) => (text === 1 ? "使用中" : text === 2 ? "已停用" : "-"),
        },
        { title: "备注", dataIndex: "remark", key: "remark", width: 100, ellipsis: true },
      ];
      return getUserRoleType() === 0 ? cols : cols.filter((col) => col.key !== "bmName");
    });
    const pageNo = ref(1);
    const pageSize = ref(10);
    const total = ref(0);
    const appList = ref([]);
    const dateFormat = ref("YYYY-MM-DD");
    const loading = ref(false);

    // 基础列配置
    const baseColumns = [
      {
        title: "广告账户ID",
        key: "adsId",
        dataIndex: "adsId",
        slots: {
          customRender: "adsId",
        },
      },
      {
        title: "广告账号名称",
        key: "adsName",
        dataIndex: "adsName",
      },
      {
        title: "时区",
        key: "gmt",
        dataIndex: "gmt",
      },
      // {
      //   title: "客户时区",
      //   key: "timeZone",
      //   dataIndex: "timeZone",
      // },
      {
        title: "母BMID",
        key: "bmName",
        dataIndex: "bmName",
      },
      {
        title: "备注",
        key: "remark",
        dataIndex: "remark",
      },
      {
        title: "子公司",
        key: "company",
        dataIndex: "company",
      },
      // {
      //   title: "冻结状态",
      //   key: "frozenState",
      //   dataIndex: "frozenState",
      //   slots: {
      //     customRender: "frozenState",
      //   },
      // },
      {
        title: "账号状态",
        key: "accountState",
        dataIndex: "accountState",
        slots: {
          customRender: "accountState",
        },
      },
      {
        title: "用户",
        key: "userId",
        dataIndex: "userId",
        slots: {
          customRender: "userId",
        },
      },
      {
        title: "用户类型",
        key: "userType",
        dataIndex: "userType",
        slots: {
          customRender: "userType",
        },
      },
      {
        title: "累计消耗($)",
        key: "expendAmount",
        dataIndex: "expendAmount",
        slots: {
          customRender: "expendAmount",
        },
      },
      {
        title: "预计服务费($)",
        key: "serviceAmount",
        dataIndex: "serviceAmount",
        slots: {
          customRender: "serviceAmount",
        },
      },
      {
        title: "已反金额($)",
        key: "returnAmount",
        dataIndex: "returnAmount",
        slots: {
          customRender: "returnAmount",
        },
      },
      {
        title: "购买价格($)",
        key: "amount",
        dataIndex: "amount",
        slots: {
          customRender: "amount",
        },
      },
    ];

    // 操作列配置
    const operationColumn = {
      title: "操作",
      key: "control",
      dataIndex: "control",
      slots: {
        customRender: "control",
      },
    };

    // 动态计算是否显示操作列
    const hasAnyOperationPermission = computed(() => {
      // 检查是否有任何操作权限
      return (
        hasPermission("sysAds.list.update") ||
        hasPermission("sysAds.list.read") ||
        hasPermission("sysAds.list.add")
      );
    });

    // 指纹编号列配置
    const fingerIdColumn = {
      title: "指纹编号",
      key: "fingerId",
      dataIndex: "fingerId",
    };

    // 获取用户信息中的 roleType
    const getUserRoleType = () => {
      const userInfo = getUserInfo();
      return userInfo?.roleType;
    };

    const isAdminUser = computed(() => getUserRoleType() === 0);

    // 动态列配置
    const columns = computed(() => {
      const cols = [...baseColumns];

      // 如果 roleType === 0，则在广告账号名称后面插入指纹编号列
      const roleType = getUserRoleType();
      if (roleType !== 0) {
        const bmNameIndex = cols.findIndex((col) => col.key === "bmName");
        if (bmNameIndex !== -1) {
          cols.splice(bmNameIndex, 1);
        }
        const userTypeIndex = cols.findIndex((col) => col.key === "userType");
        if (userTypeIndex !== -1) {
          cols.splice(userTypeIndex, 1);
        }
      }
      if (roleType === 0) {
        // 找到广告账号名称列的索引
        const adsNameIndex = cols.findIndex((col) => col.key === "adsName");
        if (adsNameIndex !== -1) {
          // 在广告账号名称后面插入指纹编号列
          cols.splice(adsNameIndex + 1, 0, fingerIdColumn);
        }
      }

      // 如果有任何操作权限，则显示操作列
      if (hasAnyOperationPermission.value) {
        cols.push(operationColumn);
      }
      return cols;
    });
    const bmColumns = computed(() => {
      const cols: any[] = [
        {
          title: "广告账户ID",
          key: "adsId",
          dataIndex: "adsId",
        },
        {
          title: "广告账户名称",
          key: "adsName",
          dataIndex: "adsName",
        },
        {
          title: "BMID",
          key: "bmId",
          dataIndex: "bmId",
        },
        {
          title: "状态",
          key: "delFlag",
          dataIndex: "delFlag",
          slots: {
            customRender: "delFlag",
          },
        },
      ];
      if (hasPermission("sysAds.list.del")) {
        cols.push({
          title: "操作",
          key: "control",
          dataIndex: "control",
          slots: {
            customRender: "control",
          },
        });
      }
      return cols;
    });
    const tableData = ref([]);
    const bmTableData = ref([]);
    const formRef = ref<FormInstance>();
    const searchFormRef = ref<FormInstance>();
    const userList = ref([]); // 用于表格显示的用户列表
    const bmDislogVisible = ref(false);
    const curRow = ref();
    const bmLoading = ref(false);
    const bmIdInput = ref("");
    const bindLoading = ref(false);
    const unbindLoading = ref<string | number | null>(null);

    // 资金清零相关状态
    const cleanAmountDislogVisible = ref(false);
    const cleanAmountLoading = ref(false);
    const cleanAmountFormRef = ref<FormInstance>();
    const cleanAmountFormState = reactive({
      id: "",
      userId: "",
      adsId: "",
      wallet: 0,
      remainingAmount: 0,
      applyType: 0,
    });

    // 额度递减相关状态
    const subAmountDislogVisible = ref(false);
    const subAmountLoading = ref(false);
    const subAmountFormRef = ref<FormInstance>();
    const subAmountFormState = reactive({
      id: "",
      userId: "",
      adsId: "",
      wallet: 0,
      remainingAmount: 0,
    });

    // 回收相关状态
    const recycleDislogVisible = ref(false);
    const recycleLoading = ref(false);
    const recycleFormState = reactive({
      id: "",
      expendAmount: 0,
      serviceAmount: 0,
      returnAmount: 0,
      amount: 0,
    });

    // 日期消耗列表相关状态
    const expendListDislogVisible = ref(false);
    const expendListLoading = ref(false);
    const expendListData = ref([]);
    const expendListDataWithTotal = ref([]); // 包含总计行的数据
    const expendListTotalAmount = ref(0); // 总计消耗金额
    const currentId = ref(""); // 列表ID，用于查询
    const currentAdsId = ref(""); // 广告账户ID，用于显示
    const expendListPageNo = ref(1);
    const expendListPageSize = ref(10);
    const expendListTotal = ref(0);
    const expendListDay = ref<string | null>(null);

    // 添加消耗记录相关状态
    const addExpendDislogVisible = ref(false);
    const addExpendLoading = ref(false);
    const addExpendFormRef = ref<FormInstance>();
    const addExpendFormState = reactive({
      day: "",
      expendAmount: 0,
      url: "",
    });
    const addExpendUrlDisabled = ref(false);
    const addExpendUploadLoading = ref(false);

    // 修改消耗记录相关状态
    const editExpendDislogVisible = ref(false);
    const editExpendLoading = ref(false);
    const editExpendFormRef = ref<FormInstance>();
    const editExpendFormState = reactive({
      id: "",
      day: "",
      expendAmount: 0,
      cleanAmount: 0,
      url: "",
    });
    const editExpendUrlDisabled = ref(false);
    const editExpendUploadLoading = ref(false);

    // 标签管理相关状态
    const labelManageVisible = ref(false);
    const labelLoading = ref(false);
    const labelTableData = ref([]);
    const labelIsAdd = ref(true);
    const labelFormVisible = ref(false);
    const labelAddLoading = ref(false);
    const labelFormRef = ref<FormInstance>();
    const labelFormState = reactive({
      id: null,
      name: "",
    });
    // 标签分页相关状态
    const labelPageNo = ref(1);
    const labelPageSize = ref(10);
    const labelTotal = ref(0);
    // 标签下拉选择相关状态
    const labelSelectOptions = ref<any[]>([]);
    const labelSelectLoading = ref(false);
    // XLS上传相关状态
    const xlsUploadLoading = ref(false);

    // 导出消耗xls相关状态
    const exportExpendVisible = ref(false);
    const exportExpendLoading = ref(false);
    const exportExpendFormRef = ref<FormInstance>();
    const exportExpendFormState = reactive({
      timeRange: null as RangeValue | null,
    });


    // 标签列表列配置
    const labelColumns = [
      {
        title: "ID",
        key: "id",
        dataIndex: "id",
        width: 80,
      },
      {
        title: "标签名称",
        key: "name",
        dataIndex: "name",
        width: 200,
      },
      {
        title: "操作",
        key: "control",
        dataIndex: "control",
        width: 150,
        slots: {
          customRender: "control",
        },
      },
    ];

    // 日期消耗列表列配置
    const expendListColumns = [
      {
        title: "日期",
        key: "day",
        dataIndex: "day",
        slots: {
          customRender: "day",
        },
      },
      {
        title: "消耗($)",
        key: "expendAmount",
        dataIndex: "expendAmount",
        slots: {
          customRender: "expendAmount",
        },
      },
      // {
      //   title: "余额($)",
      //   key: "cleanAmount",
      //   dataIndex: "cleanAmount",
      // },
      {
        title: "报表地址",
        key: "url",
        dataIndex: "url",
        slots: {
          customRender: "url",
        },
      },
      {
        title: "创建时间",
        key: "createTime",
        dataIndex: "createTime",
      },
      {
        title: "更新时间",
        key: "updateTime",
        dataIndex: "updateTime",
      },
      {
        title: "操作",
        key: "control",
        dataIndex: "control",
        slots: {
          customRender: "control",
        },
      },
    ];


    // 广告数据列表相关状态
    const adsDataList = ref([]);
    const adsListLoading = ref(false);
    const adsPageNo = ref(1);
    const adsPageSize = ref(20);
    const adsTotal = ref(0);
    const adsSearchKeyword = ref("");

    const formatMoney = (val: number | string | null | undefined) => {
      if (val === null || val === undefined || val === "") return "-";
      const num = Number(val);
      if (Number.isNaN(num)) return "-";
      return num.toFixed(2);
    };

    const search = () => {
      searchFormState.pageNo = 1;
      getData();
    };
    const resetForm = () => {
      searchFormState.pageNo = 1;
      searchFormRef.value.resetFields();
      getData();
    };
    const getAppList = () => {
      loading.value = true;
      sysNovelConfigList({}).then((res) => {
        appList.value = res.data;
        // searchFormState.appId = res.data[0].id;
        getData();
      });
    };
    const getData = () => {
      loading.value = true;
      const params = { ...searchFormState };
      sysAdsQueryList(params).then((res) => {
        loading.value = false;
        total.value = res.data.total;
        tableData.value = res.data.records;
      });
    };
    const pageNoChange = (val) => {
      searchFormState.pageNo = val;
      getData();
    };
    const onShowSizeChange = (current, size) => {
      pageSize.value = size;
      searchFormState.pageSize = size;
      searchFormState.pageNo = 1;
      pageNo.value = 1;
      getData();
    };
    const selectChange = () => {
      pageNo.value = 1;
      getData();
    };
    const addClick = () => {
      isAdd.value = 1;
      dislogVisible.value = true;
      formState.accountState = 1;
      formState.adsId = "";
      formState.adsName = "";
      formState.bmName = "";
      //   formState.company = "";
      // formState.frozenState = 0;
      formState.id = null;
      formState.userId = "";
      formState.applyState = 1; // 添加时默认为审核通过，且不可选择
      formState.price = 0;
      formState.amount = 0;
      formState.expendAmount = 0;
      formState.url = "";
      formState.gmt = "";
      formState.remark = "";
      formState.stopType = 0;
      remarkArray.value = [];
      // 重置广告数据列表
      adsPageNo.value = 1;
      adsSearchKeyword.value = "";
      getAdsDataList(true);
      // 加载标签下拉选项
      getLabelSelectOptions();
    };
    const editClick = (row: any) => {
      isAdd.value = 0;
      // 明确赋值每个字段，确保数据正确传递
      formState.id = row.id;
      formState.adsId = row.adsId;
      formState.adsName = row.adsName;
      formState.bmName = row.bmName;
      formState.userId = row.userId;
      formState.accountState = row.accountState;
      // formState.frozenState = row.frozenState;
      formState.applyState = row.applyState;
      formState.price = row.price ?? 0;
      formState.amount = row.amount || row.totalAmount || 0;
      formState.expendAmount = row.expendAmount || 0;
      formState.url = row.url || "";
      formState.gmt = row.gmt || "";
      formState.remark = row.remark || "";
      formState.stopType = row.stopType !== undefined ? row.stopType : 0;
      // 将备注字符串转换为数组用于下拉选择显示
      if (formState.remark) {
        remarkArray.value = formState.remark
          .split(",")
          .filter((item: string) => item.trim());
      } else {
        remarkArray.value = [];
      }
      dislogVisible.value = true;

      // 编辑时加载广告数据列表（用于下拉选择）
      adsPageNo.value = 1;
      adsSearchKeyword.value = "";
      getAdsDataList(true);
      // 加载标签下拉选项
      getLabelSelectOptions();
    };

    // 批量添加：表头与字段映射（模板列顺序）
    const getBatchTemplateHeaders = () => {
      const headers = [
        "账户名称",
        "时区",
        "广告账户ID",
        "母BMID",
        "用户ID",
        "账号状态",
        "备注",
      ];
      return getUserRoleType() === 0
        ? headers
        : headers.filter((header) => header !== "母BMID");
    };
    const batchAddClick = () => {
      batchAddList.value = [];
      batchAddVisible.value = true;
    };
    const parseAccountState = (val: string): number => {
      const v = String(val || "").trim();
      if (v === "已停用") return 2;
      return 1; // 使用中 或 默认
    };
    const downloadBatchTemplate = () => {
      const batchTemplateHeaders = getBatchTemplateHeaders();
      const wsData = [
        batchTemplateHeaders,
        batchTemplateHeaders.map((header) => {
          const demoData: Record<string, string> = {
            账户名称: "示例账户",
            时区: "GMT+8",
            广告账户ID: "123456789",
            母BMID: "母BMID示例",
            用户ID: "1",
            账号状态: "使用中",
            备注: "备注示例",
          };
          return demoData[header] ?? "";
        }),
      ];
      const ws = XLSX.utils.aoa_to_sheet(wsData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "批量添加模板");
      XLSX.writeFile(wb, "批量添加模板.xlsx");
    };
    const handleBatchFileUpload = (file: File) => {
      const isXls =
        file.name.endsWith(".xls") || file.name.endsWith(".xlsx");
      if (!isXls) {
        message.error("只能上传 .xls 或 .xlsx 格式的文件！");
        return false;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = e.target?.result;
          const workbook = XLSX.read(data, { type: "binary" });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const rows = XLSX.utils.sheet_to_json<any[]>(firstSheet, {
            header: 1,
            defval: "",
          });
          if (!rows || rows.length < 2) {
            message.warning("文件至少需要表头行和一行数据");
            return;
          }
          const headers = (rows[0] as any[]).map((h: any) => String(h || "").trim());
          const colMap: Record<string, number> = {};
          const batchTemplateHeaders = getBatchTemplateHeaders();
          batchTemplateHeaders.forEach((h) => {
            const idx = headers.indexOf(h);
            if (idx >= 0) colMap[h] = idx;
          });
          const list: any[] = [];
          for (let i = 1; i < rows.length; i++) {
            const row = rows[i] as any[];
            const item: Record<string, any> = {};
            batchTemplateHeaders.forEach((h) => {
              const idx = colMap[h];
              if (idx !== undefined && row[idx] !== undefined && row[idx] !== null) {
                item[h] = row[idx];
              }
            });
            const adsName = String(item["账户名称"] || "").trim();
            const adsId = String(item["广告账户ID"] || "").trim();
            const userId = String(item["用户ID"] || "").trim();
            if (!adsName || !adsId || !userId) continue; // 跳过空行
            list.push({
              key: `batch_${i}_${Date.now()}`,
              adsName,
              gmt: String(item["时区"] || "GMT+8").trim(),
              adsId,
              bmName:
                getUserRoleType() === 0
                  ? String(item["母BMID"] || "").trim()
                  : "",
              userId,
              accountState: parseAccountState(item["账号状态"]),
              applyState: 1,
              url: "",
              amount: 0,
              remark: String(item["备注"] || "").trim(),
              stopType: 0,
            });
          }
          if (list.length === 0) {
            message.warning("未解析到有效数据，请检查表格格式和必填项（账户名称、广告账户ID、用户ID）");
            return;
          }
          batchAddList.value = list;
          message.success(`成功解析 ${list.length} 条数据`);
        } catch (err) {
          console.error(err);
          message.error("解析文件失败，请检查文件格式");
        }
      };
      reader.readAsBinaryString(file);
      return false;
    };
    const confirmBatchAdd = async () => {
      if (batchAddList.value.length === 0) return;
      batchAddLoading.value = true;
      let successCount = 0;
      let failCount = 0;
      for (const item of batchAddList.value) {
        const payload = {
          id: null,
          adsName: item.adsName,
          gmt: item.gmt,
          adsId: item.adsId,
          bmName: item.bmName,
          userId: Number(item.userId),
          accountState: Number(item.accountState),
          applyState: Number(item.applyState),
          url: item.url || "",
          amount: Number(item.amount) || 0,
          expendAmount: 0,
          remark: item.remark || "",
          stopType: Number(item.stopType) || 0,
        };
        try {
          const res = await sysAdsSave(payload);
          if (res?.code === "200") successCount++;
          else failCount++;
        } catch {
          failCount++;
        }
      }
      batchAddLoading.value = false;
      message.success(`批量添加完成：成功 ${successCount} 条，失败 ${failCount} 条`);
      batchAddVisible.value = false;
      batchAddList.value = [];
      getData();
    };

    const confirm = async () => {
      try {
        const values = await formRef.value.validateFields();
        addLoading.value = true;

        if (isAdd.value === 1) {
          formState.id = null;
        }

        // 将备注数组转换为字符串
        formState.remark = remarkArray.value.join(",");

        sysAdsSave(formState).then((res) => {
          addLoading.value = false;
          if (res.code === "200") {
            dislogVisible.value = false;
            getData();
          }
        });
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
      }
    };
    const getUserListData = () => {
      userQueryPageList({}).then((res) => {
        userList.value = res.data.records;
        getData();
      });
    };

    // 广告账户ID下拉框获得焦点时
    const handleAdsFocus = () => {
      // 如果列表为空，加载第一页数据
      if (adsDataList.value.length === 0) {
        adsSearchKeyword.value = "";
        getAdsDataList(true);
      }
    };

    // 清空广告账户ID选择时重新加载全部数据
    const handleAdsClear = () => {
      adsSearchKeyword.value = "";
      formState.bmName = "";
      formState.gmt = "";
      formState.adsName = "";
      formState.price = 0;
      getAdsDataList(true);
    };

    // 资金清零
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cleanAmountClick = (row: any) => {
      // 计算当前余额：累计充值 - 累计消耗 - 已清零金额
      const remainingAmount = Math.max(
        0,
        (row.totalAmount || 0) -
          (row.expendAmount || 0) -
          (row.cleanAmount || 0)
      );
      cleanAmountFormState.id = row.id;
      cleanAmountFormState.userId = row.userId;
      cleanAmountFormState.adsId = row.adsId;
      cleanAmountFormState.remainingAmount = remainingAmount;
      cleanAmountFormState.wallet = remainingAmount; // 默认填入剩余金额
      cleanAmountFormState.applyType = 0;
      cleanAmountDislogVisible.value = true;
    };

    // 额度递减
    const subAmountClick = (row: any) => {
      const remainingAmount = Math.max(
        0,
        (row.totalAmount || 0) -
          (row.expendAmount || 0) -
          (row.cleanAmount || 0)
      );
      subAmountFormState.id = row.id;
      subAmountFormState.userId = row.userId;
      subAmountFormState.adsId = row.adsId;
      subAmountFormState.remainingAmount = remainingAmount;
      subAmountFormState.wallet = remainingAmount;
      subAmountDislogVisible.value = true;
    };

    // 确认额度递减
    const subAmountConfirm = async () => {
      try {
        await subAmountFormRef.value.validateFields();
        subAmountLoading.value = true;
        sysAdsSubAmount({
          id: subAmountFormState.id,
          userId: subAmountFormState.userId,
          adsId: subAmountFormState.adsId,
          wallet: subAmountFormState.wallet,
        })
          .then((res) => {
            subAmountLoading.value = false;
            if (res.code === "200") {
              message.success("额度递减成功！");
              subAmountDislogVisible.value = false;
              getData();
            }
          })
          .catch((error) => {
            subAmountLoading.value = false;
            console.error("额度递减失败:", error);
          });
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
      }
    };

    // 确认资金清零
    const cleanAmountConfirm = async () => {
      try {
        await cleanAmountFormRef.value.validateFields();
        cleanAmountLoading.value = true;

        sysAdsCleanAmount({
          id: cleanAmountFormState.id,
          userId: cleanAmountFormState.userId,
          adsId: cleanAmountFormState.adsId,
          wallet: cleanAmountFormState.wallet,
          applyType: cleanAmountFormState.applyType,
        })
          .then((res) => {
            cleanAmountLoading.value = false;
            if (res.code === "200") {
              message.success("资金清零成功！");
              cleanAmountDislogVisible.value = false;
              getData();
            } else {
              // message.error(res.message || "资金清零失败！");
            }
          })
          .catch((error) => {
            cleanAmountLoading.value = false;
            console.error("资金清零失败:", error);
            // message.error("资金清零失败！");
          });
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
      }
    };

    // 处理下拉菜单点击
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleMenuClick = (e: any, record: any) => {
      const { key } = e;
      switch (key) {
        case "edit":
          editClick(record);
          break;
        case "lookBm":
          lookBmClick(record);
          break;
        case "expendList":
          expendListClick(record);
          break;
        case "recycle":
          recycleClick(record);
          break;
      }
    };

    // 回收账户
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const recycleClick = (row: any) => {
      recycleFormState.id = row.id;
      recycleFormState.expendAmount = row.expendAmount ?? 0;
      recycleFormState.serviceAmount = row.serviceAmount ?? 0;
      recycleFormState.returnAmount = row.returnAmount ?? 0;
      recycleFormState.amount = row.amount ?? 0;
      recycleDislogVisible.value = true;
    };

    const recycleConfirm = () => {
      recycleLoading.value = true;
      sysAdsRecycle({ id: recycleFormState.id })
        .then((res) => {
          recycleLoading.value = false;
          if (res.code === "200") {
            message.success("回收成功！");
            recycleDislogVisible.value = false;
            getData();
          }
        })
        .catch((error) => {
          recycleLoading.value = false;
          console.error("回收失败:", error);
        });
    };

    const getBmListData = () => {
      bmLoading.value = true;
      bmQueryList({ accountId: curRow.value.id }).then((res) => {
        bmLoading.value = false;
        bmTableData.value = res.data.records;
      });
    };
    const lookBmClick = (row: any) => {
      curRow.value = row;
      bmIdInput.value = "";
      bmDislogVisible.value = true;
      getBmListData();
    };
    const bindBm = () => {
      if (!bmIdInput.value) {
        message.warning("请输入BMID");
        return;
      }
      if (!curRow.value || !curRow.value.adsId || !curRow.value.id) {
        message.warning("缺少账户信息");
        return;
      }
      bindLoading.value = true;
      bmSave({
        accountId: curRow.value.id,
        adsId: curRow.value.adsId,
        bmId: bmIdInput.value,
      })
        .then((res) => {
          bindLoading.value = false;
          if (res.code === "200") {
            message.success("绑定成功");
            bmIdInput.value = "";
            getBmListData();
          }
        })
        .catch(() => {
          bindLoading.value = false;
        });
    };
    const unbindBm = (row: any) => {
      if (!row.id) {
        message.warning("缺少ID信息");
        return;
      }
      unbindLoading.value = row.id;
      bmDel({ id: row.id })
        .then((res) => {
          unbindLoading.value = null;
          if (res.code === "200") {
            message.success("解绑成功");
            getBmListData();
          }
        })
        .catch(() => {
          unbindLoading.value = null;
        });
    };

    // 获取广告数据列表
    const getAdsDataList = (reset = false) => {
      if (reset) {
        adsPageNo.value = 1;
        adsDataList.value = [];
      }

      adsListLoading.value = true;
      sysDataQueryList({
        adsId: adsSearchKeyword.value,
        userId: "",
        status: "",
        pageNo: adsPageNo.value,
        pageSize: adsPageSize.value,
      })
        .then((res) => {
          adsListLoading.value = false;
          if (res.code === "200") {
            adsTotal.value = res.data.total;
            // 如果是重置，直接赋值；否则追加
            if (reset) {
              adsDataList.value = res.data.records || [];
            } else {
              adsDataList.value = [
                ...adsDataList.value,
                ...(res.data.records || []),
              ];
            }
          }
        })
        .catch(() => {
          adsListLoading.value = false;
        });
    };

    // 搜索广告账户ID（输入就搜索，清空显示全部）
    const handleAdsSearch = (value: string) => {
      adsSearchKeyword.value = value || "";
      getAdsDataList(true);
    };

    // 下拉滚动加载更多
    const handleAdsScroll = (e: any) => {
      const { target } = e;
      // 判断是否滚动到底部
      if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 10) {
        // 检查是否还有更多数据
        if (
          adsDataList.value.length < adsTotal.value &&
          !adsListLoading.value
        ) {
          adsPageNo.value += 1;
          getAdsDataList(false);
        }
      }
    };

    // 选择广告账户ID后自动填充母BM到母BMID
    const handleAdsIdChange = (value: string) => {
      const selectedAds = adsDataList.value.find(
        (item: any) => item.adsId === value
      );
      if (selectedAds) {
        const item = selectedAds as any;
        formState.bmName = item.bmBase || "";
        formState.gmt = item.gmt || "";
        formState.adsName = item.adsName || item.adsId || "";
        formState.price = Number(item.price ?? item.sellPrice ?? 0) || 0;
      } else {
        formState.bmName = "";
        formState.gmt = "";
        formState.adsName = "";
        formState.price = 0;
      }
    };

    // 日期消耗列表相关方法
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const expendListClick = (row: any) => {
      currentId.value = row.id; // 列表ID，用于查询
      currentAdsId.value = row.adsId || ""; // 广告账户ID，用于显示
      expendListDislogVisible.value = true;
      expendListPageNo.value = 1;
      expendListDay.value = null;
      getExpendListData();
    };

    // 获取日期消耗列表
    const getExpendListData = () => {
      expendListLoading.value = true;
      const params: any = {
        id: currentId.value,
        pageNo: expendListPageNo.value,
        pageSize: expendListPageSize.value,
      };

      // 如果有选择日期，添加日期参数（格式：yyyy-mm-dd）
      if (expendListDay.value) {
        params.day = expendListDay.value;
      }
      console.log(currentId.value);
      // 同时获取列表和总计
      Promise.all([
        sysAdsExpendList(params),
        sysAdsExpendCount({ id: currentId.value }),
      ])
        .then(([listRes, countRes]) => {
          expendListLoading.value = false;
          if (listRes.code === "200") {
            expendListData.value = listRes.data?.records || [];
            expendListTotal.value = listRes.data?.total || 0;
          }
          if (countRes.code === "200") {
            expendListTotalAmount.value =
              Number(countRes.data?.expendAmount) || 0;
          } else {
            expendListTotalAmount.value = 0;
          }
          // 更新包含总计行的数据
          updateExpendListDataWithTotal();
        })
        .catch(() => {
          expendListLoading.value = false;
        });
    };

    // 更新包含总计行的数据
    const updateExpendListDataWithTotal = () => {
      const data = [...expendListData.value];
      // 在顶部添加总计行
      data.unshift({
        day: "总计",
        expendAmount: expendListTotalAmount.value,
        url: "",
        createTime: "",
        updateTime: "",
        id: "total", // 标识为总计行
        isTotal: true, // 标识为总计行
      });
      expendListDataWithTotal.value = data;
    };

    // 日期范围改变（移除自动查询，改为手动点击查询按钮）
    // const handleExpendListDateChange = () => {
    //   expendListPageNo.value = 1;
    //   getExpendListData();
    // };

    // 查询按钮点击
    const handleExpendListSearch = () => {
      expendListPageNo.value = 1;
      getExpendListData();
    };

    // 分页改变
    const expendListPageNoChange = (val: number) => {
      expendListPageNo.value = val;
      getExpendListData();
    };

    // 每页条数改变
    const expendListShowSizeChange = (current: number, size: number) => {
      expendListPageNo.value = 1;
      expendListPageSize.value = size;
      getExpendListData();
    };

    // 添加消耗记录
    const addExpendClick = () => {
      addExpendFormState.day = "";
      addExpendFormState.expendAmount = 0;
      addExpendFormState.url = "";
      addExpendUrlDisabled.value = false;
      addExpendDislogVisible.value = true;
    };

    // 添加消耗记录 - 文件上传
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleAddExpendUpload = (file: any) => {
      const formData = new FormData();
      formData.append("file", file);

      addExpendUploadLoading.value = true;
      commonUpload(formData)
        .then((res) => {
          addExpendUploadLoading.value = false;
          if (res.code === "200" && res.data) {
            addExpendFormState.url = res.data;
            addExpendUrlDisabled.value = true; // 上传后禁止输入
            message.success("上传成功！");
          } else {
            // message.error(res.message || "上传失败！");
          }
        })
        .catch((error) => {
          addExpendUploadLoading.value = false;
          // console.error("上传失败:", error);
          // message.error("上传失败！");
        });

      return false; // 阻止自动上传
    };

    // 确认添加消耗记录
    const addExpendConfirm = async () => {
      try {
        await addExpendFormRef.value.validateFields();
        addExpendLoading.value = true;

        sysAdsSaveExpend({
          adsId: currentAdsId.value,
          day: addExpendFormState.day,
          expendAmount: addExpendFormState.expendAmount,
          url: addExpendFormState.url,
          accountId: currentId.value,
        })
          .then((res) => {
            addExpendLoading.value = false;
            if (res.code === "200") {
              message.success("添加成功！");
              addExpendDislogVisible.value = false;
              getExpendListData(); // 重新加载消耗列表
              getData(); // 刷新广告账户列表
            } else {
              // message.error(res.message || "添加失败！");
            }
          })
          .catch((error) => {
            addExpendLoading.value = false;
            // console.error("添加失败:", error);
            // message.error("添加失败！");
          });
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
      }
    };

    // 修改消耗记录
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const editExpendClick = (row: any) => {
      editExpendFormState.id = row.id;
      editExpendFormState.day = row.day || "";
      editExpendFormState.expendAmount = row.expendAmount || 0;
      editExpendFormState.cleanAmount = row.cleanAmount || 0;
      editExpendFormState.url = row.url || "";
      editExpendUrlDisabled.value = !!row.url; // 如果有URL，则禁用输入
      editExpendDislogVisible.value = true;
    };

    // 修改消耗记录 - 文件上传
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleEditExpendUpload = (file: any) => {
      const formData = new FormData();
      formData.append("file", file);

      editExpendUploadLoading.value = true;
      commonUpload(formData)
        .then((res) => {
          editExpendUploadLoading.value = false;
          if (res.code === "200" && res.data) {
            editExpendFormState.url = res.data;
            editExpendUrlDisabled.value = true; // 上传后禁止输入
            message.success("上传成功！");
          } else {
            // message.error(res.message || "上传失败！");
          }
        })
        .catch((error) => {
          editExpendUploadLoading.value = false;
          // console.error("上传失败:", error);
          // message.error("上传失败！");
        });

      return false; // 阻止自动上传
    };

    // 确认修改消耗记录
    const editExpendConfirm = async () => {
      try {
        await editExpendFormRef.value.validateFields();
        editExpendLoading.value = true;

        sysAdsSaveExpend({
          id: editExpendFormState.id,
          adsId: currentAdsId.value,
          accountId: currentId.value,
          day: editExpendFormState.day,
          expendAmount: editExpendFormState.expendAmount,
          url: editExpendFormState.url,
        })
          .then((res) => {
            editExpendLoading.value = false;
            if (res.code === "200") {
              message.success("修改成功！");
              editExpendDislogVisible.value = false;
              getExpendListData(); // 重新加载消耗列表
              getData(); // 刷新广告账户列表
            } else {
              // message.error(res.message || "修改失败！");
            }
          })
          .catch((error) => {
            editExpendLoading.value = false;
            // console.error("修改失败:", error);
            // message.error("修改失败！");
          });
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
      }
    };

    // 标签管理相关方法
    const labelClick = () => {
      labelManageVisible.value = true;
      labelPageNo.value = 1;
      getLabelList();
    };

    // 获取标签列表
    const getLabelList = () => {
      labelLoading.value = true;
      sysLabelQueryList({
        pageNo: labelPageNo.value,
        pageSize: labelPageSize.value,
      })
        .then((res) => {
          labelLoading.value = false;
          if (res.code === "200") {
            labelTableData.value = res.data.records || [];
            labelTotal.value = res.data.total || 0;
          }
        })
        .catch(() => {
          labelLoading.value = false;
        });
    };

    // 标签分页改变
    const labelPageNoChange = (val: number) => {
      labelPageNo.value = val;
      getLabelList();
    };

    // 标签每页条数改变
    const labelShowSizeChange = (current: number, size: number) => {
      labelPageNo.value = 1;
      labelPageSize.value = size;
      getLabelList();
    };

    // 获取标签下拉选项（用于备注字段）
    const getLabelSelectOptions = () => {
      labelSelectLoading.value = true;
      sysLabelQueryList({})
        .then((res) => {
          labelSelectLoading.value = false;
          if (res.code === "200") {
            const records = res.data.records || [];
            labelSelectOptions.value = records.map((item: any) => ({
              label: item.name,
              value: item.name,
            }));
          }
        })
        .catch(() => {
          labelSelectLoading.value = false;
        });
    };

    // 添加标签
    const labelAddClick = () => {
      labelIsAdd.value = true;
      labelFormState.id = null;
      labelFormState.name = "";
      labelFormVisible.value = true;
    };

    // 编辑标签
    const labelEditClick = (row: any) => {
      labelIsAdd.value = false;
      labelFormState.id = row.id;
      labelFormState.name = row.name || "";
      labelFormVisible.value = true;
    };

    // 删除标签
    const labelDelClick = (row: any) => {
      sysLabelDel({ id: row.id })
        .then((res) => {
          if (res.code === "200") {
            message.success("删除成功！");
            getLabelList();
            // 刷新标签下拉选项
            getLabelSelectOptions();
          } else {
            // message.error(res.message || "删除失败！");
          }
        })
        .catch(() => {
          // message.error("删除失败！");
        });
    };

    // 确认添加/编辑标签
    const labelConfirm = async () => {
      try {
        await labelFormRef.value?.validateFields();
        labelAddLoading.value = true;

        const submitData: any = {
          name: labelFormState.name,
        };

        // 只有编辑时才传递id
        if (!labelIsAdd.value && labelFormState.id) {
          submitData.id = labelFormState.id;
        }

        sysLabelSave(submitData)
          .then((res) => {
            labelAddLoading.value = false;
            if (res.code === "200") {
              message.success(labelIsAdd.value ? "添加成功！" : "修改成功！");
              labelFormVisible.value = false;
              getLabelList();
              // 刷新标签下拉选项
              getLabelSelectOptions();
            } else {
              // message.error(res.message || "操作失败！");
            }
          })
          .catch((error) => {
            labelAddLoading.value = false;
            // console.error("保存失败:", error);
            // message.error("操作失败！");
          });
      } catch (errorInfo) {
        console.log("表单验证失败:", errorInfo);
      }
    };

    // 处理XLS文件上传
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleXlsUpload = (file: any) => {
      // 检查文件类型
      const isXls =
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.name.endsWith(".xls") ||
        file.name.endsWith(".xlsx");

      if (!isXls) {
        message.error("只能上传 .xls 或 .xlsx 格式的文件！");
        return false;
      }

      const formData = new FormData();
      formData.append("file", file);

      xlsUploadLoading.value = true;
      commonUpload(formData)
        .then((res) => {
          if (res.code === "200" && res.data) {
            const fileUrl = res.data;
            // 上传成功后，调用 xls 接口更新消耗
            return sysAdsXls({ url: fileUrl });
          } else {
            throw new Error(res.message || "上传失败！");
          }
        })
        .then((res) => {
          xlsUploadLoading.value = false;
          if (res.code === "200") {
            message.success("上传并更新消耗成功！");
            // 刷新列表数据
            getData();
          } else {
            // message.error(res.message || "更新消耗失败！");
          }
        })
        .catch((error) => {
          xlsUploadLoading.value = false;
          console.error("上传或更新失败:", error);
          // message.error(error.message || "上传或更新失败！");
        });

      return false; // 阻止自动上传
    };

    // 导出消耗xls - 点击按钮
    const exportExpendClick = () => {
      exportExpendFormState.timeRange = null;
      exportExpendVisible.value = true;
    };

    // 导出消耗xls - 确认导出
    const exportExpendConfirm = async () => {
      try {
        await exportExpendFormRef.value?.validateFields();
        if (!exportExpendFormState.timeRange || exportExpendFormState.timeRange.length !== 2) {
          message.error("请选择时间范围！");
          return;
        }

        exportExpendLoading.value = true;
        const [beginTime, endTime] = exportExpendFormState.timeRange;
        
        // 处理日期格式：如果是dayjs对象则格式化，如果是字符串则直接使用
        const beginTimeStr = typeof beginTime === 'string' ? beginTime : beginTime.format("YYYY-MM-DD");
        const endTimeStr = typeof endTime === 'string' ? endTime : endTime.format("YYYY-MM-DD");
        
        sysExpendGetExpendxls({
          starDay: beginTimeStr,
          endDay: endTimeStr,
        })
          .then((res: any) => {
            exportExpendLoading.value = false;
            // 处理文件下载
            if (res instanceof Blob) {
              const url = window.URL.createObjectURL(res);
              const link = document.createElement("a");
              link.href = url;
              link.download = `消耗数据_${beginTimeStr}_${endTimeStr}.xls`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
              message.success("导出成功！");
              exportExpendVisible.value = false;
            } else if (res && res.code === "200") {
              message.success("导出成功！");
              exportExpendVisible.value = false;
            } else {
              // 如果返回的是blob但被包装了，尝试从response中获取
              message.error("导出失败，请重试！");
            }
          })
          .catch((error) => {
            exportExpendLoading.value = false;
            console.error("导出失败:", error);
            message.error("导出失败，请重试！");
          });
      } catch (errorInfo) {
        console.log("表单验证失败:", errorInfo);
      }
    };

    const recycleRecordClick = () => {
      router.push("/recycle");
    };

    onMounted(() => {
      getUserListData();
    });
    return {
      isAdminUser,
      hasPermission,
      userList,
      isAdd,
      formRef,
      dislogVisible,
      addClick,
      batchAddClick,
      batchAddVisible,
      batchAddLoading,
      batchAddList,
      batchAddColumns,
      downloadBatchTemplate,
      handleBatchFileUpload,
      confirmBatchAdd,
      confirm,
      searchFormState,
      searchFormRef,
      formState,
      addLoading,
      columns,
      formatMoney,
      appList,
      tableData,
      pageNo,
      pageSize,
      dateFormat,
      total,
      loading,
      bmDislogVisible,
      bmColumns,
      bmLoading,
      bmTableData,
      search,
      resetForm,
      pageNoChange,
      onShowSizeChange,
      selectChange,
      editClick,
      lookBmClick,
      bindBm,
      unbindBm,
      bmIdInput,
      bindLoading,
      unbindLoading,
      adsDataList,
      adsListLoading,
      handleAdsSearch,
      handleAdsScroll,
      handleAdsIdChange,
      handleAdsFocus,
      handleAdsClear,
      cleanAmountClick,
      cleanAmountConfirm,
      cleanAmountDislogVisible,
      cleanAmountLoading,
      cleanAmountFormRef,
      cleanAmountFormState,
      subAmountClick,
      subAmountConfirm,
      subAmountDislogVisible,
      subAmountLoading,
      subAmountFormRef,
      subAmountFormState,
      recycleClick,
      recycleConfirm,
      handleMenuClick,
      recycleDislogVisible,
      recycleLoading,
      recycleFormState,
      timeZoneList,
      expendListClick,
      expendListDislogVisible,
      expendListLoading,
      expendListData,
      expendListDataWithTotal,
      expendListColumns,
      currentId,
      currentAdsId,
      editExpendClick,
      editExpendConfirm,
      editExpendDislogVisible,
      editExpendLoading,
      editExpendFormRef,
      editExpendFormState,
      expendListPageNo,
      expendListPageSize,
      expendListTotal,
      expendListDay,
      handleExpendListSearch,
      expendListPageNoChange,
      expendListShowSizeChange,
      addExpendClick,
      addExpendConfirm,
      addExpendDislogVisible,
      addExpendLoading,
      addExpendFormRef,
      addExpendFormState,
      addExpendUrlDisabled,
      addExpendUploadLoading,
      handleAddExpendUpload,
      editExpendUrlDisabled,
      editExpendUploadLoading,
      handleEditExpendUpload,
      labelClick,
      labelManageVisible,
      labelLoading,
      labelTableData,
      labelColumns,
      labelAddClick,
      labelEditClick,
      labelDelClick,
      labelConfirm,
      labelFormState,
      labelFormRef,
      labelIsAdd,
      labelAddLoading,
      labelFormVisible,
      labelSelectOptions,
      labelSelectLoading,
      remarkArray,
      labelPageNo,
      labelPageSize,
      labelTotal,
      labelPageNoChange,
      labelShowSizeChange,
      handleXlsUpload,
      xlsUploadLoading,
      exportExpendClick,
      exportExpendVisible,
      exportExpendLoading,
      exportExpendFormRef,
      exportExpendFormState,
      exportExpendConfirm,
      recycleRecordClick,
    };
  },
};
